import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AccountInputSearch from "../../../../commons/components/AccountInputSearch";
import AccountSelectSearch from "../../../../commons/components/AccountSelectSearch";
import AccountSelectOption from "../../../../commons/components/AccountSelectOption";
import AccountButtonAdd from "../../../../commons/components/AccountButtonAdd";

import {
    usersSetSearchUser,
    usersSetFilterPartner,
    usersSetFilterApplication,
    usersSetShowUserModal,
    usersSetModeUserModal,
} from "../../../../store/actions/usersActions";

import newUserModalModes from "../NewUserModal/newUserModalModes";
import Http from "../../../../commons/utils/Http";
import Permissions from "../../../../commons/utils/permissions";

import { RowFilters, ColFields, ColButtons } from './cardSearchStyles';

function CardSearch(props) {
    const dispatch = useDispatch();
    const { screens } = useSelector(state => state.userLogin);
    const { searchUser, filterPartner, filterApplication } = useSelector(state => state.users);
    const [permissions] = useState([]);

    const [partners, setPartners] = useState([]);
    const [applications, setApplications] = useState([]);

    const [searchUserValue, setSearchUserValue] = useState(searchUser);

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/users") {
                    screen.functions.map(func => {
                        permissions.push(func)
                    })
                }
            });

            getApplications();
        }
    }, [screens]);

    function getApplications() {
        Http.get(`/applications/get-all?offset=${0}&order=${"name"}`, Http.headers)
            .then(response => {
                const responseData = response.data;
                if (!responseData.response.error) {
                    setApplications(formatSelectApplicationsData(responseData.data));
                }
            }).catch(err => {
                setApplications([]);
            })
    }

    function searchPartners(search) {
        Http.get(`/partners/search?search=${search}`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    setPartners(formatSelectPartnersData(responseData.data));
                }
            }).catch(err => {
                setPartners([]);
            })
    }

    function formatSelectApplicationsData(data) {
        let array = [];
        if (data) {
            data.forEach((dataItem) => {
                let item = {}
                item.label = `${dataItem.name}`;
                item.value = dataItem.id;
                array.push(item)
            })
        }
        return array;
    }

    function formatSelectPartnersData(data) {
        let array = [];
        if (data) {
            data.forEach((dataItem) => {
                let item = {}
                if (dataItem.id != 1 && dataItem.trading_name != "PARCEIRO DEFAULT") {
                    item.label = `${dataItem.codparc + " - " + dataItem.trading_name}`;
                    item.value = dataItem.id;
                    array.push(item)
                }
            })
        }
        return array;
    }

    function handleInsertUser() {
        dispatch(usersSetModeUserModal(newUserModalModes.INSERT));
        dispatch(usersSetShowUserModal(true));
    }

    function handleOnChangeApplication(value, item) {
        dispatch(usersSetFilterApplication(item ? item : {}));
    }

    function handleOnChangePartner(value, item) {
        dispatch(usersSetFilterPartner(item ? item : {}));
    }

    function handleOnSearchPartner(search) {
        searchPartners(search);
    }

    function handleOnSearchUser(search) {
        dispatch(usersSetSearchUser(search));
    }

    function handleOnChangeUser(input) {
        setSearchUserValue(input.target.value)
    }

    function renderButtons() {
        if (permissions.find(_function => _function.function_id === Permissions.CRIAR_USUARIO)) {
            return (
                <AccountButtonAdd
                    label="Criar novo usuário"
                    onClick={handleInsertUser}
                />
            )
        }
    }

    return (
        <RowFilters>
            <ColFields flex="auto">
                <AccountInputSearch
                    value={searchUserValue}
                    placeholder="Pesquisar usuário"
                    style={{ width: 300, marginRight: 6 }}
                    onSearch={handleOnSearchUser}
                    onChange={handleOnChangeUser}
                />
                <AccountSelectSearch
                    value={filterPartner.children}
                    placeholder="Parceiro"
                    style={{ width: 300, marginRight: 6 }}
                    data={partners}
                    onSearch={handleOnSearchPartner}
                    onChange={handleOnChangePartner}
                    allowClear={true}
                    showSearch={true}
                />
                <AccountSelectOption
                    value={filterApplication.children}
                    placeholder="Aplicações"
                    style={{ width: 300, marginRight: 6 }}
                    data={applications}
                    onChange={handleOnChangeApplication}
                    allowClear={true}
                    showSearch={true}
                />
            </ColFields>
            <ColButtons>
                {renderButtons()}
            </ColButtons>
        </RowFilters>
    )
}

export default CardSearch;
